<template>
  <footer class="footer-container d-none d-lg-block">
    <div class="container py-5 px-3">
      <div class="row g-4 justify-content-between">
        <!-- Column 1: Brand & App Download -->
        <div class="col-lg-4 col-md-6 text-start">
          <div class="footer-brand d-flex align-items-center gap-2 mb-2">
            <img src="@/assets/img/loidoc_logo_white.png" alt="Lối Đọc" class="footer-logo-img" />
            <span class="footer-brand-title font-serif">Lối Đọc</span>
          </div>
          <p class="footer-tagline mb-4">
            Mạng xã hội đọc sách &amp; Sàn giao dịch sách cũ C2C an toàn cho độc giả Việt Nam.
          </p>

          <div class="footer-app-download">
            <h5 class="app-download-title mb-2">TẢI ỨNG DỤNG LỐI ĐỌC</h5>
            <div class="download-badges d-flex align-items-center gap-2 flex-wrap">
              <!-- App Store Button -->
              <a href="#" class="btn-store-badge" title="Tải về trên App Store" @click.prevent>
                <icon :icon="['fab', 'apple']" class="store-badge-icon" />
                <div class="store-badge-text">
                  <span class="store-sub">DOWNLOAD ON THE</span>
                  <strong class="store-name">App Store</strong>
                </div>
              </a>

              <!-- Google Play Button -->
              <a href="#" class="btn-store-badge" title="Tải về trên Google Play" @click.prevent>
                <icon :icon="['fab', 'google-play']" class="store-badge-icon" />
                <div class="store-badge-text">
                  <span class="store-sub">GET IT ON</span>
                  <strong class="store-name">Google Play</strong>
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- Column 2: Công ty & Pháp lý -->
        <div class="col-lg-4 col-md-6 text-start ps-lg-5">
          <h4 class="footer-section-title mb-3">CÔNG TY &amp; PHÁP LÝ</h4>
          <ul class="footer-legal-list list-unstyled d-flex flex-column gap-3">
            <li>
              <a href="https://kientaotech.com/" target="_blank" rel="noopener noreferrer" class="footer-nav-item d-flex align-items-center gap-2">
                <icon icon="fa-solid fa-arrow-up-right-from-square" class="nav-icon" />
                <span>Về Kiến Tạo Tech (About Us)</span>
              </a>
            </li>
            <li>
              <router-link to="/terms" class="footer-nav-item d-flex align-items-center gap-2">
                <icon icon="fa-solid fa-file-contract" class="nav-icon" />
                <span>Điều khoản dịch vụ (Terms)</span>
              </router-link>
            </li>
            <li>
              <router-link to="/privacy" class="footer-nav-item d-flex align-items-center gap-2">
                <icon icon="fa-solid fa-lock" class="nav-icon" />
                <span>Chính sách bảo mật (Privacy)</span>
              </router-link>
            </li>
            <li>
              <router-link to="/help" class="footer-nav-item d-flex align-items-center gap-2">
                <icon icon="fa-solid fa-circle-question" class="nav-icon" />
                <span>Trợ giúp &amp; Báo cáo bản quyền</span>
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Column 3: Kết nối -->
        <div class="col-lg-3 col-md-6 text-start">
          <h4 class="footer-section-title mb-3">KẾT NỐI</h4>
          <div class="social-circles-group d-flex align-items-center gap-2 mb-3">
            <a href="#" class="social-circle-item" title="Facebook" aria-label="Facebook" @click.prevent>
              <icon :icon="['fab', 'facebook-f']" />
            </a>
            <a href="#" class="social-circle-item" title="YouTube" aria-label="YouTube" @click.prevent>
              <icon :icon="['fab', 'youtube']" />
            </a>
            <a href="#" class="social-circle-item" title="TikTok" aria-label="TikTok" @click.prevent>
              <icon :icon="['fab', 'tiktok']" />
            </a>
            <a href="#" class="social-circle-item" title="Instagram" aria-label="Instagram" @click.prevent>
              <icon :icon="['fab', 'instagram']" />
            </a>
          </div>

          <p class="footer-support-label mb-1">
            Mọi thắc mắc và khiếu nại bản quyền xin gửi về:
          </p>
          <a href="mailto:support@kientaotech.com" class="footer-support-email">
            support@kientaotech.com
          </a>
        </div>
      </div>

      <hr class="footer-bottom-divider my-4" />

      <!-- Sub-footer Bottom Bar -->
      <div class="row align-items-center">
        <div class="col-12 text-center text-md-start">
          <p class="footer-copyright mb-0.5">© 2026 Lối Đọc</p>
          <p class="footer-creator mb-0">
            Một sản phẩm thuộc <span class="kientao-highlight">Kiến Tạo Tech</span>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script src="./Footer.js"></script>
<style scoped src="./Footer.css"></style>
